<template>

  <div class="event-entry">
    <!--<div :style="{ background: this.getCategoryColor() }" class="event-category"></div>-->
    <img class="event-image" :src="imgUrl()">
<div class="event-title-info">
  <div class="event-title" :style="{ color: getTitleColor() }"><b>{{ this.eventData.title }}</b></div>
  <div class="event-info" v-html="this.eventData.description"></div>
</div>

    <div class="event-details">
      <strong class="event-date"><img class="icon" src="/images/calendar_591607.png" alt="calendar">{{ this.formattedStartDate() }}
        {{ this.formattedEndDate() }}
      </strong>
      <div class="event-location" ><img class="icon" src="/images/map-location_3986275.png" alt="location"><div v-html="this.eventData.location"></div></div>
      <div class="event-organizer"><img class="icon" src="/images/support_2058768.png" alt="organiser"> {{ this.eventData.organizer }}
      </div>
    </div>
  </div>


</template>

<script>
export default {
  props: {
    eventData: {
      type: Object,
      required: true,
    },
    settingData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      isLoading: false,
    };
  },
  methods: {
    getCategoryColor() {
      const category = this.eventData.attributes.category;

      const categoryColors = {
        'Ausflug, Führung, Tour': '#3498db',   // Blau
        'Ausstellung': '#e74c3c',            // Rot
        'Ball, Umzug': '#f1c40f',            // Gelb
        'Fest, Brauchtum': '#27ae60',         // Grün
        'Film': '#8e44ad',                   // Lila
        'Gesundheit, Soziales': '#e67e22',    // Orange
        'Jugend': '#2ecc71',                 // Türkis
        'Kirche, Religion': '#1abc9c',       // Dunkelgrün
        'Kulinarisches': '#d35400',          // Rostrot
        'Kurs, Seminar, Tagung': '#95a5a6',  // Grau
        'Messe, Kongress, Markt': '#e91e63',  // Pink
        'Musik, Konzerte': '#9b59b6',        // Violett
        'Schulveranstaltung, Kinderveranstaltung': '#16a085', // Smaragdgrün
        'Senioren': '#f39c12',               // Sonnengelb
        'Sonstige': '#bdc3c7',               // Silbergrau
        'Sport, Freizeit': '#1abc9c',        // dark green same
        'Theater, Kabarett, Show': '#c0392b', // Ruby Red
        'Versammlung': '#34981b',            // blue
        'Vortrag, Lesung': '#2c3e50',        // darkblue
      };

      return categoryColors[category] || '#bdc3c7';
    },
    formattedStartDate() {
      const endDate = new Date(this.eventData.end_date);
      const eventDate = new Date(this.eventData.start_date);
      const options = {year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'};
      if (this.eventData.end_date === ""){
        return eventDate.toLocaleDateString('de-AT', options);

      }
      else {
        if (eventDate.toDateString() === endDate.toDateString()) {
          const options1 = {year: 'numeric', month: 'long', day: 'numeric'};
          const options2 = {hour: 'numeric', minute: 'numeric'};
          return eventDate.toLocaleDateString('de-AT', options1) + "\n"
              + eventDate.toLocaleTimeString('de-AT', options2) + " -";
        }
        else {
          return eventDate.toLocaleDateString('de-AT', options) + " - ";
        }
      }
    },
    imgUrl() {
      return 'https://infoboard.samc.at' + this.eventData.image;
    },
    formattedEndDate() {
      const startDate = new Date(this.eventData.start_date);
      const endDate = new Date(this.eventData.end_date);

      if (startDate.toDateString() === endDate.toDateString()) {
        const options = {hour: 'numeric', minute: 'numeric'};
        return endDate.toLocaleTimeString('de-AT', options);
      } else if (this.eventData.end_date === "") {
        return "";
      } else {
        const options = {year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'};
        return "\n" + endDate.toLocaleDateString(undefined, options);
      }
    },
    getTitleColor() {
      return this.settingData.schema === 'blau' ? '#0799cc' : '#006666';
    },
  },
};
</script>

<style scoped>

.event-entry {
  flex-direction: row;
  display: flex;
  height: 19%;
  width: 98%;
  margin-top: 0.7%;
  margin-left: 0.7%;
//box-shadow: 6px 6px 1px 1px rgba(0, 0, 0, 0.2); //border: 1px solid darkgray; //border-radius: 10px; overflow: hidden;
  margin-bottom: 0.7%;
}

.event-category {
  display: flex;
  flex-direction: column;
  width: 2%;
  height: 100%;
  background: lightsalmon;
}

.event-title-info {
  font-size: 1vh;
  width: 48%;
  height: 100%;
  margin-right: 2%;
}

.event-date {
  padding: 0;
  color: #505050;
  font-size: 1vh;
  display: flex;
  width: 100%;
  flex-direction: row;
  height: fit-content; /* probably 33.3% */
  align-items: center;
  margin-top: 3%;
  white-space: pre;
}

.event-organizer {
  color: #505050;
  width: 100%;
  font-size: 1vh;
  display: flex;
  flex-direction: row;
  height: fit-content; /* probably 33.3% */
  align-items: center;
  margin-bottom: 3%;
}


.event-image {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 30%;
  border-radius: 0.5vh;
  object-fit: cover; /*probaly weg damit*/
}

.event-details {
  display: flex;
  flex-direction: column;
  width: 20%;
  height: 100%;
  align-items: center;
  justify-content: space-between; /* evtl. weg */
}




.event-title {
  font-size: 1.8vh;
  padding-top: 0;
  display: flex;
  width: 80%;
}


.event-location {
  color: #505050;
  font-size: 1vh;
  margin: 0;
  padding: 0;
  display: flex;
  width: 100%;
  flex-direction: row;
  height: 33.3%;
  align-items: center;
}

.event-info {
  color: #505050;
  font-size: 1vh;
  margin-right: 1%;
  margin-left: 2%;
  margin-bottom: 0.5%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 8; /* Maximum of 7 lines */
  overflow: hidden;
}

.icon{
  height: auto;
  width: 15%;
  display: flex;
  margin-right: 5%;
}



</style>
